import { useContext, useState } from "react";
import styled from "styled-components";
import CardConstructor from "./CardConstructor";
import Modal from "./Modal";
import { AppContext } from "../App";

const About = ({ open }: { open: boolean }) => {
  const { setAbout: close, setClaim } = useContext(AppContext);
  const [activeFaq, setActiveFaq] = useState<number>(0);

  const activateFaq = (n: number) => {
    if (n === activeFaq) {
      setActiveFaq(n - activeFaq);
    } else {
      setActiveFaq(n);
    }
  };

  return (
    <Modal isOpen={open}>
      <Wrapper isOpen={open}>
        <CardConstructor
          $margin={"0 auto"}
          $width={"45%"}
          centered={false}
          aboveTitleContent={
            <button
              className="btn-flat btn navigation-btn"
              onClick={() => close()}
            >
              <i className="material-icons">arrow_back</i> Back
            </button>
          }
          title={<h5 className="about-title">About My Life Plan</h5>}
          content={
            <div className="content">
              <h5 className="content-heading">A map of you.</h5>
              <p>
                This isn’t another personality quiz or goal-setting tool. It’s a
                new kind of digital space — where your story, intentions, and
                values are front and center.
              </p>
              <p>
                We believe most tools ask the wrong questions — or worse, give
                answers that aren't really yours.
              </p>
              <p>
                This platform helps you reflect, explore, and connect the dots
                in your own voice — through short videos, writing, and a visual
                map that grows as you do
              </p>
              <p>It’s built to feel alive, intimate, and completely yours.</p>
              <p>
                A bit like therapy meets personal OS — minus the jargon and
                overwhelm.
              </p>
              <h5 className="content-heading">How it works.</h5>
              <ul className="directions">
                <li>
                  You record or write your thoughts, stories, and priorities
                </li>
                <li>The map connects them visually</li>
                <li>You decide how you use that and what others see</li>
              </ul>
              <button
                onClick={() => {
                  close();
                  setClaim((prev: boolean) => !prev);
                }}
                className="sign-up"
              >
                Claim My <span className="life-plan">Life Plan</span>
              </button>

              <hr />
              <h5 className="content-heading">FAQ.</h5>
              <ul>
                <li>
                  <p className="faq-title" onClick={() => activateFaq(1)}>
                    What is this for?{" "}
                    {activeFaq === 1 ? (
                      <i className="material-icons">arrow_drop_up</i>
                    ) : (
                      <i className="material-icons">arrow_drop_down</i>
                    )}
                  </p>
                  {activeFaq === 1 ? (
                    <p className="faq-answers animate__animated animate__fadeIn">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Iure voluptatum, impedit dolore a possimus minima ab
                      distinctio. Sapiente quos quo error quidem porro tempore
                      sit, vitae quisquam voluptatum aspernatur totam? Lorem
                      ipsum dolor sit amet consectetur, adipisicing elit.
                      Voluptate, iste nesciunt molestiae soluta dicta tenetur
                      maxime suscipit necessitatibus cum fugiat. Numquam aliquid
                      blanditiis modi dolores nisi commodi rem id nostrum?
                    </p>
                  ) : (
                    <></>
                  )}
                </li>
                <li>
                  <p className="faq-title" onClick={() => activateFaq(2)}>
                    Do I need to be “a content creator”?{" "}
                    {activeFaq === 2 ? (
                      <i className="material-icons">arrow_drop_up</i>
                    ) : (
                      <i className="material-icons">arrow_drop_down</i>
                    )}
                  </p>
                  {activeFaq === 2 ? (
                    <p className="faq-answers animate__animated animate__fadeIn">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Iure voluptatum, impedit dolore a possimus minima ab
                      distinctio. Sapiente quos quo error quidem porro tempore
                      sit, vitae quisquam voluptatum aspernatur totam? Lorem
                      ipsum dolor sit amet consectetur, adipisicing elit.
                      Voluptate, iste nesciunt molestiae soluta dicta tenetur
                      maxime suscipit necessitatibus cum fugiat. Numquam aliquid
                      blanditiis modi dolores nisi commodi rem id nostrum?
                    </p>
                  ) : (
                    <></>
                  )}
                </li>
                <li>
                  <p className="faq-title" onClick={() => activateFaq(3)}>
                    Is this private?{" "}
                    {activeFaq === 3 ? (
                      <i className="material-icons">arrow_drop_up</i>
                    ) : (
                      <i className="material-icons">arrow_drop_down</i>
                    )}
                  </p>
                  {activeFaq === 3 ? (
                    <p className="faq-answers animate__animated animate__fadeIn">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Iure voluptatum, impedit dolore a possimus minima ab
                      distinctio. Sapiente quos quo error quidem porro tempore
                      sit, vitae quisquam voluptatum aspernatur totam? Lorem
                      ipsum dolor sit amet consectetur, adipisicing elit.
                      Voluptate, iste nesciunt molestiae soluta dicta tenetur
                      maxime suscipit necessitatibus cum fugiat. Numquam aliquid
                      blanditiis modi dolores nisi commodi rem id nostrum?
                    </p>
                  ) : (
                    <></>
                  )}
                </li>
                <li>
                  <p className="faq-title" onClick={() => activateFaq(4)}>
                    Why video?{" "}
                    {activeFaq === 4 ? (
                      <i className="material-icons">arrow_drop_up</i>
                    ) : (
                      <i className="material-icons">arrow_drop_down</i>
                    )}
                  </p>
                  {activeFaq === 4 ? (
                    <p className="faq-answers animate__animated animate__fadeInDown">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Iure voluptatum, impedit dolore a possimus minima ab
                      distinctio. Sapiente quos quo error quidem porro tempore
                      sit, vitae quisquam voluptatum aspernatur totam? Lorem
                      ipsum dolor sit amet consectetur, adipisicing elit.
                      Voluptate, iste nesciunt molestiae soluta dicta tenetur
                      maxime suscipit necessitatibus cum fugiat. Numquam aliquid
                      blanditiis modi dolores nisi commodi rem id nostrum?
                    </p>
                  ) : (
                    <></>
                  )}
                </li>
                <li>
                  <p className="faq-title" onClick={() => activateFaq(5)}>
                    What’s the waitlist for?{" "}
                    {activeFaq === 5 ? (
                      <i className="material-icons">arrow_drop_up</i>
                    ) : (
                      <i className="material-icons">arrow_drop_down</i>
                    )}
                  </p>
                  {activeFaq === 5 ? (
                    <p className="faq-answers animate__animated animate__fadeIn">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Iure voluptatum, impedit dolore a possimus minima ab
                      distinctio. Sapiente quos quo error quidem porro tempore
                      sit, vitae quisquam voluptatum aspernatur totam? Lorem
                      ipsum dolor sit amet consectetur, adipisicing elit.
                      Voluptate, iste nesciunt molestiae soluta dicta tenetur
                      maxime suscipit necessitatibus cum fugiat. Numquam aliquid
                      blanditiis modi dolores nisi commodi rem id nostrum?
                    </p>
                  ) : (
                    <></>
                  )}
                </li>
                <li>
                  <p className="faq-title" onClick={() => activateFaq(6)}>
                    Who made this?{" "}
                    {activeFaq === 6 ? (
                      <i className="material-icons">arrow_drop_up</i>
                    ) : (
                      <i className="material-icons">arrow_drop_down</i>
                    )}
                  </p>
                  {activeFaq === 6 ? (
                    <p className="faq-answers animate__animated animate__fadeIn">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Iure voluptatum, impedit dolore a possimus minima ab
                      distinctio. Sapiente quos quo error quidem porro tempore
                      sit, vitae quisquam voluptatum aspernatur totam? Lorem
                      ipsum dolor sit amet consectetur, adipisicing elit.
                      Voluptate, iste nesciunt molestiae soluta dicta tenetur
                      maxime suscipit necessitatibus cum fugiat. Numquam aliquid
                      blanditiis modi dolores nisi commodi rem id nostrum?
                    </p>
                  ) : (
                    <></>
                  )}
                </li>
              </ul>
            </div>
          }
        />
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  .about-title {
    font-size: 35px;
    letter-spacing: -0.3px;
    font-weight: 700;
    margin-top: -10px;
    font: inter;
  }

  .navigation-btn,
  .navigation-btn:hover {
    text-transform: none;
    display: flex;
    align-items: center;
    color: #243aff;
    background-color: unset;
    padding-left: 0;
  }

  .content {
    margin-top: -5px;
  }

  .content p,
  ul.directions li {
    font-size: 12px;
    margin-bottom: 10px;
  }

  ul.directions li {
    list-style-type: disc;
    margin-left: 15px;
  }

  .content-heading {
    font-size: 24px;
    font-weight: 600;
  }

  .card-content {
    padding: 25px;
  }

  .sign-up {
    background: #243aff;
    color: white;
    padding: 10px;
    border-radius: 30px;
    border: transparent;
    cursor: pointer;
  }

  .sign-up:hover {
    border: 0.25px solid #2339ff;
  }

  hr {
    margin-top: 30px;
  }

  p.faq-title {
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  @media only screen and (max-width: 650px) {
    .about-title {
      font-size: 22px;
    }
  }
`;

export default About;
